import { Button, Modal } from '@/ui';
import PropTypes from 'prop-types';

import './OrgModales.css';

const RESULTADO_COLOR = {
  realizada: 'var(--ok)',
  'no-habida': 'var(--err)',
};

export function InformacionReceptoresModal({
  open,
  onClose,
  caseId,
  receptores,
}) {
  return (
    <Modal open={open} onClose={onClose} size="xlarge">
      <Modal.Header
        title={`Información de receptores · ${caseId ?? ''}`}
        onClose={onClose}
      />
      <Modal.Body noPadding>
        <table className="info-receptores-table">
          <thead>
            <tr>
              <th>Receptor</th>
              <th>Diligencia</th>
              <th className="num">Fecha</th>
              <th>Resultado</th>
            </tr>
          </thead>
          <tbody>
            {receptores?.map((row, i) => (
              <tr key={i}>
                <td>{row.receptor}</td>
                <td>{row.diligencia}</td>
                <td className="num">
                  <span className="info-receptores-date">{row.fecha}</span>
                </td>
                <td>
                  <span
                    className="info-receptores-resultado"
                    style={{
                      color:
                        RESULTADO_COLOR[row.resultadoKey] ?? 'var(--ink-3)',
                    }}
                  >
                    ● {row.resultado}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Foot>
        <Button variant="seal" onClick={onClose}>
          Cerrar
        </Button>
      </Modal.Foot>
    </Modal>
  );
}

InformacionReceptoresModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  caseId: PropTypes.string,
  receptores: PropTypes.arrayOf(
    PropTypes.shape({
      receptor: PropTypes.string,
      diligencia: PropTypes.string,
      fecha: PropTypes.string,
      resultado: PropTypes.string,
      resultadoKey: PropTypes.oneOf(['realizada', 'no-habida']),
    }),
  ),
};

export default InformacionReceptoresModal;
